// import Swiper from 'swiper';
// // import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// import 'swiper/css/bundle';
// export default Swiper;

// Importa Swiper Core
import Swiper from 'swiper';
// Importa esclusivamente i moduli richiesti
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Importa i fogli di stile essenziali
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Registra i moduli sul costruttore globale tramite Swiper.use in Swiper 14
Swiper.use([Navigation, Pagination, Autoplay]);

export default Swiper;